<dx-drawer
  data-testid="inner-toolbar-drawer"
  class="drawer"
  position="before"
  [openedStateMode]="menuMode"
  [revealMode]="menuRevealMode"
  [minSize]="minMenuSize"
  [shading]="shaderEnabled"
  [(opened)]="menuOpened">

  <app-side-navigation-menu
    data-testid="inner-toolbar-nav-menu"
    [compactMode]="!menuOpened"
    [selectedItem]="selectedRoute"
    class="dx-swatch-additional"
    *dxTemplate="let dataMenu of 'panel'"
    (selectedItemChanged)="navigationChanged($event)"
    (openMenu)="navigationClick($event)">
      <dx-toolbar data-testid="navigation-header" id="navigation-header">
        <dxi-toolbar-item
          data-testid="menu-button-item"
          *ngIf="minMenuSize !== 0"
          location="before"
          cssClass="menu-button"
          widget="dxButton"
          id="menu-button"
          [options]="{
            icon: 'menu',
            stylingMode: 'text',
            onClick: toggleMenu
          }">
        </dxi-toolbar-item>
      </dx-toolbar>
  </app-side-navigation-menu>

  <div data-testid="inner-toolbar-container" class="container">
    <app-header
      data-testid="inner-toolbar-header"
      [menuToggleEnabled]="minMenuSize === 0"
      (menuToggle)="menuOpened = !menuOpened;">
    </app-header>




    <!-- <dx-scroll-view data-testid="side-nav-inner-toolbar-layout-body" class="layout-body with-footer" [disabled]="true"> -->

      <div data-testid="inner-toolbar-content" class="content">
        <ng-content></ng-content>
      </div>
      <div data-testid="inner-toolbar-footer-block" class="content-block">
        <ng-content select="app-footer"></ng-content>
      </div>
    <!-- </dx-scroll-view> -->
  </div>
</dx-drawer>

